export default __webpack_public_path__ + "static/media/denoche.fcfd59b7.jpg";